module.exports = __webpack_public_path__ + "static/media/friends.8917894a.svg";